import { RouteParam } from ".";
import { WarehouseCard } from "../ui/pages/warehouse_team_management/warehouses";
import InwardListScreen from "../ui/pages/warehouse_team_management/inward/InwardListScreen";
import { ACTION, MODULE } from "../utils/enums";
import { urls } from "../utils/urls";
import { TeamManagement } from "../ui/pages/warehouse_team_management/team";
import InventoryDashboard from "../ui/pages/warehouse_team_management/Inventory/InventoryDashboard";
import { WarehouseDashboard } from "../ui/pages/warehouse_team_management/dashboard";
import { WarehouseLogs } from "../ui/pages/warehouse_team_management/logs";
import WarehouseOutwardDashboardWrapper from "../ui/pages/warehouse_team_management/outward/warehouse_outward_dashboard";
import WarehouseStockTransferWrapper from "../ui/pages/warehouse_team_management/stock-transfer/warehouse_stock_transfer";
import WarehouseFinanceDashboardWrapper from "../ui/pages/warehouse_team_management/finance/warehouse_finance_dashboard";
import CreateStockTransferPage from "../ui/pages/warehouse_team_management/stock-transfer/CreateStockTransferPage";
import StockLedgerDashboard from "../ui/pages/warehouse_team_management/stock-ledger-dashboard/stock-ledger-dashboard";
import InwardReceivePage from "../ui/pages/warehouse_team_management/inward/InwardReceivePage";
import QuarantineDashboard from "../ui/pages/warehouse_team_management/quarantine-management/QuarantineDashboard";
import InfraPOInwardReceivePage from "../ui/pages/warehouse_team_management/inward/POInfraInwardScreen";
import FaultyResolution from "../ui/pages/warehouse_team_management/Inventory/FaultyResolution";

const warehouse_panel_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_dashboard,
    component: WarehouseDashboard,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_panel,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_panel,
    component: WarehouseCard,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_team_management,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_inward,
    component: InwardListScreen,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_inward,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_inward + "/receive/:type/:inward_order_id",
    component: InwardReceivePage,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_inward,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_inward + "/receive/:type/:poType/:inward_order_id",
    component: InfraPOInwardReceivePage,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_inward,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_panel + "/outward",
    component: WarehouseOutwardDashboardWrapper,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_outward,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_panel + "/stock-transfers",
    component: WarehouseStockTransferWrapper,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_stock_transfers,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_panel + "/create-stock-transfer",
    component: CreateStockTransferPage,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_stock_transfers,
    action: [ACTION.READ, ACTION.CREATE],
    operator: "and",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_panel + "/finance",
    component: WarehouseFinanceDashboardWrapper,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_finance,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_team,
    component: TeamManagement,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_module_team_management,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_inventory,
    component: InventoryDashboard,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_inventory_dashboard,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_stock_ledger,
    component: StockLedgerDashboard,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_stock_ledger,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_quarantine,
    component: QuarantineDashboard,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_quarantine_dashboard,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_faulty_resolution,
    component: FaultyResolution,
    main_module: MODULE.warehouse_panel,
    module: MODULE.faulty_device_resolution,
    action: [ACTION.READ, ACTION.CREATE, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.warehouse_logs,
    component: WarehouseLogs,
    main_module: MODULE.warehouse_panel,
    module: MODULE.warehouse_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default warehouse_panel_routes;
